import Vue from 'vue';
import VueResource from 'vue-resource';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

export default {
  relatorioLancamentos: idProjeto => {
    return Vue.http.get(`/api/transparencia/${idProjeto}/RelatorioLancamentos`)
      .then(response => response.data);
  },
  relatorioPagamentoPessoaFisica: idProjeto => {
    return Vue.http.get(`/api/transparencia/${idProjeto}/RelatorioPagamentoPessoaFisica`)
      .then(response => response.data);
  },
  relatorioPagamentoAgente: idProjeto => {
    return Vue.http.get(`/api/transparencia/${idProjeto}/RelatorioPagamentoAgente`)
      .then(response => response.data);
  },
  relatorioPagamentoAluno: idProjeto => {
    return Vue.http.get(`/api/transparencia/${idProjeto}/RelatorioPagamentoAluno`)
      .then(response => response.data);
  },
  relatorioPagamentoClt: idProjeto => {
    return Vue.http.get(`/api/transparencia/${idProjeto}/RelatorioPagamentoClt`)
      .then(response => response.data);
  },
  relatorioPagamentoPessoaJuridica: idProjeto => {
    return Vue.http.get(`/api/transparencia/${idProjeto}/RelatorioPagamentoPessoaJuridica`)
      .then(response => response.data);
  },
  relatorioRubricas: idProjeto => {
    return Vue.http.get(`/api/transparencia/${idProjeto}/RelatorioRubricas`)
      .then(response => response.data);
  },
  relatorioComprasLicitacoes: idProjeto => {
    return Vue.http.get(`/api/transparencia/${idProjeto}/RelatorioComprasLicitacoes`)
      .then(response => response.data);
  },
  relatorioItensComprasLicitacoes: (idProjeto, idPedidoCompra) => {
    return Vue.http.get(`/api/transparencia/${idProjeto}/RelatorioItensComprasLicitacoes/${idPedidoCompra}`)
      .then(response => response.data);
  },
  relatorioTransparencia: (pagina, idCoordenador, idOrgaoFinanciador, tituloProjeto, dataInicio, dataFim, objetivo, numeroConvenio, numeroProcesso, idMaisFiltros, idTipoOrgao) => {
    return Vue.http.get('/api/transparencia/RelatorioTransparencia', {
      params: {
        pagina,
        idCoordenador,
        idOrgaoFinanciador,
        tituloProjeto,
        dataInicio,
        dataFim,
        objetivo,
        numeroConvenio,
        numeroProcesso,
        idMaisFiltros,
        idTipoOrgao
      }
    })
      .then(response => response.data);
  },
  coordenadores: () => {
    return Vue.http.get('/api/transparencia/coordenadores')
      .then(response => response.data);
  },
  orgaosFinaciadores: () => {
    return Vue.http.get('/api/transparencia/OrgaosFinaciadores')
      .then(response => response.data);
  },
  orgaosFinaciadoresProjeto: id => {
    return Vue.http.get(`/api/transparencia/${id}/OrgaosFinaciadores`)
      .then(response => response.data);
  },
  informacaoProjeto: id => {
    return Vue.http.get(`/api/transparencia/${id}/InformacaoTransparencia`)
      .then(response => response.data);
  },
  arquivos: id => {
    return Vue.http.get(`/api/transparencia/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
    return Vue.http.get(`/api/transparencia/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/transparencia/servico.js